import React, { createContext, useContext, useEffect } from 'react';
import './css/gridSistem.css';
import './css/style.scss';
import { Redirect, Route, Switch, useHistory, withRouter, } from 'react-router-dom';
import SignUpContainer from './components/SignUp/SignUpContainer';
import LoginContainer from './components/Login/LoginContainer';
import ObjectsContainer from './components/Objects/ObjectsContainer';
import CssBaseline from '@material-ui/core/CssBaseline';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles/';
import BookingContainer from './components/Booking/BookingContainer';
import BookingDetailContainer from './components/BookingDetail/BookingDetailContainer';
import ReviewsContainer from './components/Reviews/ReviewsContainer';
import SignUpWithPhoneContainer from './components/SignUp/SignUpWithPhone/SignUpWithPhoneContainer';
import SignUpWithMailContainer from './components/SignUp/SignUpWithMail/SignUpWithMailContainer';
import InvoicesContainer from './components/Invoices/InvoicesContainer';
import { inicializeApp } from './globalState/app/actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Preloader from './components/common/Preloader/Preloader';
import ForgotPasswordContainer from './components/ForgotPassword/ForgotPasswordContainer';
import ObjectMainContainer from './components/ObjectMain/ObjectMainContainer';
import ObjectAddNewContainer from './components/ObjectAddNew/ObjectAddNewContainer';
import NotFoundContainer from './components/common/NotFound/NotFoundContainer';
import ObjectAboutContainer from './components/ObjectAbout/ObjectAboutContainer';
import ObjectPhotoContainer from './components/ObjectPhoto/ObjectPhotoContainer';
import ObjectLocationContainer from './components/ObjectLocation/ObjectLocationContainer';
import ObjectContactsContainer from './components/ObjectContacts/ObjectContactsContainer';
import ObjectServicesContainer from './components/ObjectServices/ObjectServicesContainer';
import ObjectRulesContainer from './components/ObjectRules/ObjectRulesContainer';
import ObjectRoomsContainer from './components/ObjectRooms/ObjectRoomsContainer';
import ObjectRoomEditContainer from './components/ObjectRoomEdit/ObjectRoomEditContainer';
import PriceTableControllerContainer from './components/common/PriceTableController/PriceTableControllerContainer';
import UserSettingsContainer from './components/UserSettings/UserSettingsContainer';
import ContractsContainer from './components/Contracts/ContractsContainer';
import ContractDetailContainer from './components/ContractsDetail/ContractDetailContainer';
import ObjectRatePlansContainer from './components/ObjectRatePlans/ObjectRatePlansContainer';
import CalendarBusyContainer from './components/CalendarBusy/CalendarBusyContainer';
import AccessRightContainer from './components/AccessRight/AccessRightContainer';
import AccessRightDetailContainer from './components/AccessRightDetail/AccessRightDetailContainer';
import CalendarBusyInObjectContainer from './components/CalendarBusy/CalendarBusyInObjectContainer';
import ChannelManagerContainer from './components/ChannelManager/ChannelManagerContainer';
import ConfirmAccountContainer from './components/ConfirmAccount/ConfirmAccountContainer';
import HistoryContainer from './components/History/HistoryContainer';
import ScrollToTop from './components/common/CustomHook/ScrollToTop';
import ChangePasswordContainer from './components/ForgotPassword/ChangePasswordContainer';
import RedirectedPageContainer from './components/common/RedirectedPageTemporary/RedirectedPageContainer';
import ObjectStockContainer from './components/ObjectStock/ObjectStockContainer';
import ContractSampleContainer from './components/ContractSample/ContractSampleContainer';
import { useQuery } from './components/common/CustomHook/useQuery';
import FastCreateObjectContainer from './components/FastCreateObject/FastCreateObjectContainer';

const THEME = createMuiTheme({
  typography: {
    fontFamily: `"Montserrat", "Helvetica", "Arial", sans-serif`,
  },

  overrides: {
    MuiCssBaseline: {
      '@global': {
        body: {
          color: '#4f4f4f',
          fontSize: '1rem',
          lineHeight: 1.6,
        },
        p: {
          marginTop: 0,
          marginBottom: '1rem',
        },
      },
    },
    MuiButton: {
      root: {
        textTransform: 'none',
        fontWeight: 400,
        lineHeight: 1.5,
      },
    },
    MuiLink: {
      root: {
        color: '#3f51b5',
        '&:hover': {
          color: '#7986cb',
          textDecoration: 'none',
        },
      },
    },
    MuiButtonBase: {
      root: {},
    },
    MuiDialog: {
      scrollPaper: {
        alignItems: 'start',
      },
    },
    MuiCardContent: {
      root: {
        padding: '16px',
      },
    },
  },
  palette: {
    primary: {
      main: 'rgba(0, 0, 0, 0.87)',
    },
    secondary: {
      main: '#FFF',
    },
    background: {
      default: '#fff',
    },
  },
});

// region userIsAuth context
const AuthContext = createContext(false);

const AuthContextProvider = ({ userIsAuth, children }) => {
  return (
    <AuthContext.Provider value={userIsAuth}>{children}</AuthContext.Provider>
  );
};

const UseIsAuth = () => {
  return useContext(AuthContext);
};
// endregion userIsAuth context

//region isMobile context
const IsMobileContext = createContext(false);
const IsMobileContextProvider = ({ isMobile, children }) => {
  return (
    <IsMobileContext.Provider value={isMobile}>
      {children}
    </IsMobileContext.Provider>
  );
};

// endregion

//region useUserVerified context
const UserVerifiedContext = createContext('N');
const UserVerifiedContextProvider = ({ userVerified, children }) => {
  return (
    <UserVerifiedContext.Provider value={userVerified}>
      {children}
    </UserVerifiedContext.Provider>
  );
};
export const useUserVerified = () => {
  return useContext(UserVerifiedContext);
};
// endregion

// region userRole context
const UserRoleContext = createContext('');

const UserRoleContextProvider = ({ userRole, children }) => {
  return (
    <UserRoleContext.Provider value={userRole}>
      {children}
    </UserRoleContext.Provider>
  );
};

export const useUserRole = () => {
  return useContext(UserRoleContext);
};
// endregion

const PrivateRoute = ({ component: Component, ...rest }) => {
  const userIsAuth = UseIsAuth();

  return (
    <Route
      {...rest}
      render={(props) =>
        userIsAuth ? (
          <Component {...props} {...rest} />
        ) : (
          <Redirect
            to={{
              pathname: '/lk/login',
            }}
          />
        )
      }
    />
  );
};

const App = (props) => {
  const {
    userIsAuth,
    inicialized,
    inicializeApp,
    leftMenuActive,
    userRole,
    isMobile,
    userVerified,
  } = props;

  const query = useQuery();
  let confirmCode = query.get('utm_source');

  const history = useHistory();

  useEffect(() => {
    if (confirmCode) {
      localStorage.setItem('utmSource', confirmCode);
      history.push(history.location.pathname);
    }
  }, []);

  useEffect(() => {
    inicializeApp();
  }, [inicializeApp]);

  useEffect(() => {
    if (userRole === 'TOURIST') {
      window.location.href = 'https://edem-v-gosti.ru/personal/';
    }
  }, [userRole]);

  useEffect(() => {
    if (leftMenuActive) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'visible';
    }
  }, [leftMenuActive]);

  if (!inicialized) {
    return <Preloader loading={true} text={'Загрузка...'}/>;
  }

  return (
    <div className='app-wrp'>
      <ScrollToTop/>
      <MuiThemeProvider theme={THEME}>
        <AuthContextProvider userIsAuth={userIsAuth}>
          <UserRoleContextProvider userRole={userRole}>
            <UserVerifiedContextProvider userVerified={userVerified}>
              <IsMobileContextProvider isMobile={isMobile}>
                <CssBaseline/>
                <Switch>
                  <Route
                    exact
                    path='/lk/confirm-account'
                    component={ConfirmAccountContainer}
                  />
                  <Route
                    exact
                    path='/lk/change-password'
                    component={ChangePasswordContainer}
                  />
                  <PrivateRoute
                    exact
                    path='/lk'
                    component={ObjectsContainer}
                    userIsAuth={userIsAuth}
                  />
                  <Route
                    exact
                    path='/lk/login'
                    component={LoginContainer}
                  />
                  <Route
                    exact
                    path='/lk/registration'
                    component={SignUpContainer}
                  />
                  <Route
                    exact
                    path='/lk/registration/phone'
                    component={SignUpWithPhoneContainer}
                  />
                  <Route
                    exact
                    path='/lk/registration/mail'
                    component={SignUpWithMailContainer}
                  />
                  <Route
                    exact
                    path='/lk/forgotpassword'
                    component={ForgotPasswordContainer}
                  />
                  {/*<Route exact path="/lk/faq" component={FaqContainer}/>*/}
                  <PrivateRoute
                    exact
                    path='/lk/profile'
                    component={UserSettingsContainer}
                  />
                  {/*<Route exact path="/lk/recovery-access" component={RecoveryAccessToObjectFreeContainer}/>*/}
                  <PrivateRoute
                    exact
                    path='/lk/booking/:objectId?'
                    component={BookingContainer}
                  />
                  <PrivateRoute
                    exact
                    path='/lk/booking/detail/:bookingId?'
                    component={BookingDetailContainer}
                  />
                  <PrivateRoute
                    exact
                    path='/lk/reviews/:objectId?'
                    component={ReviewsContainer}
                  />
                  <PrivateRoute
                    exact
                    path='/lk/busy-calendar/:objectId?'
                    component={CalendarBusyContainer}
                  />
                  <PrivateRoute
                    exact
                    path='/lk/invoices/:objectId?'
                    component={InvoicesContainer}
                  />
                  <PrivateRoute
                    exact
                    path='/lk/contracts'
                    component={ContractsContainer}
                  />
                  <PrivateRoute
                    exact
                    path='/lk/contracts/sample'
                    component={ContractSampleContainer}
                  />
                  <PrivateRoute
                    exact
                    path='/lk/contracts/:contractId?'
                    component={ContractDetailContainer}
                  />

                  <PrivateRoute
                    exact
                    path='/lk/access-right'
                    component={AccessRightContainer}
                  />
                  <PrivateRoute
                    exact
                    path='/lk/access-right/detail/:objectId?'
                    component={AccessRightDetailContainer}
                  />
                  <PrivateRoute
                    exact
                    path='/lk/newObject'
                    component={ObjectAddNewContainer}
                  />
                  <PrivateRoute
                    exact
                    path='/lk/:objectId?'
                    component={ObjectMainContainer}
                  />
                  <PrivateRoute
                    exact
                    path='/lk/:objectId?/channel-manager'
                    component={ChannelManagerContainer}
                  />
                  <PrivateRoute
                    exact
                    path='/lk/:objectId?/about'
                    component={ObjectAboutContainer}
                  />
                  <PrivateRoute
                    exact
                    path='/lk/:objectId?/bookings'
                    component={BookingContainer}
                    inObject={true}
                  />
                  <PrivateRoute
                    exact
                    path='/lk/:objectId?/stock'
                    component={ObjectStockContainer}
                  />
                  <PrivateRoute
                    exact
                    path='/lk/:objectId?/photo'
                    component={ObjectPhotoContainer}
                  />
                  <PrivateRoute
                    exact
                    path='/lk/:objectId?/distances'
                    component={ObjectLocationContainer}
                  />
                  <PrivateRoute
                    exact
                    path='/lk/:objectId?/contacts'
                    component={ObjectContactsContainer}
                  />
                  <PrivateRoute
                    exact
                    path='/lk/:objectId?/services'
                    component={ObjectServicesContainer}
                  />
                  <PrivateRoute
                    exact
                    path='/lk/:objectId?/conditions'
                    component={ObjectRulesContainer}
                  />
                  <PrivateRoute
                    exact
                    path='/lk/:objectId?/rooms'
                    component={ObjectRoomsContainer}
                  />
                  <PrivateRoute
                    exact
                    path='/lk/:objectId?/rooms/:roomId?'
                    component={ObjectRoomEditContainer}
                  />
                  <PrivateRoute
                    exact
                    path='/lk/:objectId?/rate-plans'
                    component={ObjectRatePlansContainer}
                  />
                  <PrivateRoute
                    exact
                    path='/lk/:objectId?/calendar/:roomId?'
                    component={PriceTableControllerContainer}
                  />
                  <PrivateRoute
                    exact
                    path='/lk/:objectId?/busy-calendar/:roomId?'
                    component={CalendarBusyInObjectContainer}
                  />
                  <PrivateRoute
                    exact
                    path='/lk/:objectId?/history'
                    component={HistoryContainer}
                  />
                  <PrivateRoute
                    exact
                    path='/lk/:objectId?/fastCreateObject'
                    component={FastCreateObjectContainer}
                  />

                  {/*TODO временные редиректы для страницы из писем*/}
                  <Route
                    exact
                    path='/lk/:id?/contract'
                    component={RedirectedPageContainer}
                  />
                  <Route
                    exact
                    path='/lk/:id?/booking'
                    component={RedirectedPageContainer}
                  />
                  <Route
                    exact
                    path='/lk/:id?/booking/:detailId?'
                    component={RedirectedPageContainer}
                  />
                  {/*TODO временные редиректы для страницы из писем*/}

                  <Route exact path='*' component={NotFoundContainer}/>
                </Switch>
              </IsMobileContextProvider>
            </UserVerifiedContextProvider>
          </UserRoleContextProvider>
        </AuthContextProvider>
      </MuiThemeProvider>
    </div>
  );
};

let mapStateToProps = (state) => {
  return {
    inicialized: state.app.inicialized,
    userIsAuth: state.user.userIsAuth,
    userVerified: state.user.verified,
    leftMenuActive: state.app.leftMenuActive,
    userRole: state.user.role,
    isMobile: state.app.isMobile,
  };
};

export default compose(
  connect(mapStateToProps, { inicializeApp }),
  withRouter
)(App);
